import React, { useEffect, useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';

import { ClientFile } from '../../interfaces/ClientFile';
import FileUploader from '../../components/FileUploader';
import { FileType } from '../../interfaces/FileType';
import { uploadFile } from '../../utils/api/files';
import FileGallery from './FileGallery';
import FilesList from './FilesList';

import { Client } from '../../interfaces/Client';
import { Pension } from '../../interfaces/Pension';
import { Onboarding } from '../../interfaces/Onboarding';
import { TaxReturn } from '../../interfaces/taxReturn';
import { Insurance } from '../../interfaces/Insurance';
import globalErrorHandler from '../../utils/globalErrorHandler';

interface FilesPageContentProps {
    client: Client;
    currentRound?: Pension | Onboarding | TaxReturn | Insurance;
}

const FilesPageContent = ({ client, currentRound }: FilesPageContentProps) => {
    const { t } = useTranslation();

    const [newFile, setNewFile] = useState<ClientFile>();
    const [lastChange, setLastChange] = useState<Date>();

    const onFileUpload = async (file: FileType) => {
        try {
            const result = await uploadFile({ clientId: client._id, file });
            setNewFile(result.file);
        } catch (err: any) {
            if (err.status === 402) return alert('Employer data is missing (Jotform 3)');

            if (err.status === 403) return alert('Client Israeli ID does not match the uploaded file');

            globalErrorHandler(err);
        }
    };

    useEffect(() => {
        console.log('client1', client);
    }, [client]);

    const onFileChanged = () => {
        setLastChange(new Date());
    };

    return (
        <div>
            <Row>
                <Col xl={4} lg={4}>
                    {<FilesList shortList={false} currentRound={currentRound} client={client} lastChange={lastChange} />}
                </Col>
                <Col xl={8} lg={8}>
                    {<FileGallery client={client} currentRound={currentRound} onChange={onFileChanged} newfile={newFile} />}

                    <Card>
                        <Card.Body>
                            <h4 className="header-title mb-3">File Upload</h4>

                            <p className="font-13 m-b-30">Drag and drop any files relevant for the user during and after the Zoom call</p>

                            <FileUploader showPreview={true} onFileUpload={onFileUpload} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default FilesPageContent;
